// Global
import React from 'react';

// Local
import styles from './FeatureDetailCard.module.scss';

import { FeatureImageAndTextProps } from '../FeatureImageAndText';
import clsx from 'clsx';

export type FeatureDetailCardProps = FeatureImageAndTextProps & {
  contentAlignment?: 'left' | 'center' | 'right';
};

export const FeatureDetailCard = (props: FeatureDetailCardProps) => {
  /*
   * Rendering
   */

  const contentAlignment = props?.contentAlignment || 'left';
  const contentPosition = props?.contentPosition || 'ContentRight';

  return (
    <div
      className={clsx(
        styles.featureDetailCard,
        styles[`contentAlignment__${contentAlignment}`],
        styles[`contentPosition__${contentPosition}`],
        styles.standardVariant
      )}
    >
      <div className={styles.copyBlock}>
        {props.icon && <div className={styles.icon}>{props.icon}</div>}
        {props.eyebrow && <span className={styles.eyebrow}>{props.eyebrow}</span>}
        {props.headline &&
          (props.headlineLevel === 3 ? (
            <div className={styles.titleWrapper} role="heading" aria-level={3}>
              {props.headline}
            </div>
          ) : (
            <h2 className={styles.titleWrapper}>{props.headline}</h2>
          ))}

        {props.description && <div className={styles.description}>{props.description}</div>}
      </div>

      {(props.cta1 || props.cta2) && (
        <div
          className={clsx(
            styles.featureCtaContainer,
            contentAlignment === 'center' ? styles[`contentAlignment__${contentAlignment}`] : '',
            styles.standardVariant
          )}
        >
          {props.cta1 && <div className={styles.cta1}>{props.cta1}</div>}
          {props.cta2 && <div className={styles.cta2}>{props.cta2}</div>}
        </div>
      )}
    </div>
  );
};
